import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import OffenceService from '@services/offence'

export const getMajorOffenders = createAsyncThunk('majorOffenders/getMajorOffenders', async (params) => {
  const response = await OffenceService.getMajorOffenders(params)
  return { params, data: response.data, totalPages: response.meta.itemCount }
})

export const getOffenderDemerits = createAsyncThunk('majorOffenders/getOffenderDemerits', async (identifier) => {
  const response = await OffenceService.getOffenderDemerits(identifier)
  return response
})

const MajorOffendersSlice = createSlice({
  name: 'majorOffenders',
  initialState: {
    data: [],
    total: 1,
    params: {},
    offenderDemerits: [],
    selectedOffender: null
  },
  reducers: {
    setSelectedOffender: (state, action) => {
      state.selectedOffender = action.payload
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getMajorOffenders.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getOffenderDemerits.fulfilled, (state, action) => {
        state.offenderDemerits = action.payload
      })
  }
})

export const { setSelectedOffender } = MajorOffendersSlice.actions
export default MajorOffendersSlice.reducer
